import { render } from "./CombinationComposer.vue?vue&type=template&id=2bdb5d8f"
import script from "./CombinationComposer.vue?vue&type=script&lang=js"
export * from "./CombinationComposer.vue?vue&type=script&lang=js"

import "./CombinationComposer.vue?vue&type=style&index=0&id=2bdb5d8f&lang=scss"

import exportComponent from "/home/runner/work/MMXD_CardOptimizer/MMXD_CardOptimizer/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__